import { render, staticRenderFns } from "./Territorio.vue?vue&type=template&id=79558a6e&lang=pug"
import script from "./Territorio.vue?vue&type=script&lang=js"
export * from "./Territorio.vue?vue&type=script&lang=js"
import style0 from "./Territorio.vue?vue&type=style&index=0&id=79558a6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports